/**
 * The industry list a `select` field named `industry` offers.
 *
 * **These are our own reports' industries**, asked for on 2026-08-26 — the
 * seventeen Industry Focus cuts of the Digital & AI Maturity Report 2026 in
 * `content/reports.ts`, which is the taxonomy we already publish against. It
 * replaces the empty placeholder that had been waiting for HubSpot's list: a
 * sector we cut a report for is a sector we can name, and a question with no
 * answers in it is the defect being fixed here (the same reasoning that filled
 * Country in).
 *
 * The Future 2030 outlooks add no eighteenth sector — every one of them is one
 * of these under a slightly different name (Energy & Utilities, Pharmaceutical),
 * so the Focus set is the whole taxonomy.
 *
 * **Written out in sorted order, not derived from `REPORTS` and not sorted at
 * runtime.** Same reason as `countries.ts`: the home page hydrates and a
 * literal cannot disagree with itself. Alphabetical rather than the reports
 * page's order, which puts Airports before Airlines and is a ranking rather
 * than an index — somebody scanning a picker is looking one place only.
 *
 * A sector we have no report for is still a real enquiry, which is what the
 * `other` free-text box beside this list is for (see `pageForms.ts`). When the
 * HubSpot embed finally replaces these fields its own list arrives with it and
 * this file can go.
 */
export const INDUSTRIES = [
  'Airlines',
  'Airports',
  'Automotive',
  'Banking',
  'Construction',
  'Consumer Goods',
  'Energy',
  'Insurance',
  'Logistics',
  'Manufacturing',
  'Pharmaceuticals',
  'Public Services',
  'Retail',
  'Services',
  'Technology',
  'Tourism',
  'Utilities',
]

/**
 * The same seventeen sectors in Turkish, in the same order as the English list.
 *
 * Beside `COUNTRIES` and `COUNTRIES_TR` in `countries.ts`, and here for the same
 * reason: Country and Industry are the two fields a Turkish reader has to pick
 * their own answer out of, and both the closing band form and the Turkish
 * Contact Us form ask them. Kept in the English list's order rather than
 * re-sorted by the Turkish alphabet so the two lists stay readable side by side
 * as one taxonomy.
 */
export const INDUSTRIES_TR = [
  'Havayolları',
  'Havalimanları',
  'Otomotiv',
  'Bankacılık',
  'İnşaat',
  'Tüketim Ürünleri',
  'Enerji',
  'Sigorta',
  'Lojistik',
  'Üretim',
  'İlaç',
  'Kamu Hizmetleri',
  'Perakende',
  'Hizmetler',
  'Teknoloji',
  'Turizm',
  'Altyapı Hizmetleri',
]
